import React from "react";
import { Button, Space } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import Alert from "./GxAlert";
import { toJalali } from "../utils/dateUtils";

/** نوارِ «پیش‌نویسِ ذخیره‌نشده پیدا شد — ادامه / دور بریز» (v2.142.0). `draft` = خروجیِ `useDraft`. */
export default function DraftBar({ draft, onRestore, what = "اطلاعاتِ واردشده" }) {
  if (!draft?.pending) return null;
  const d = new Date(draft.pending.at);
  const hm = d.toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" });
  const day = toJalali(d.toISOString().slice(0, 10));
  return (
    <Alert type="warning" showIcon icon={<HistoryOutlined />} style={{ marginBottom: 10 }}
      message={`${what} که ذخیره نشده بود، به‌صورتِ پیش‌نویس نگه داشته شده (${day} ساعت ${hm})`}
      description="احتمالاً صفحه برای بروزرسانی یا قطعی بسته شده. «ادامه» همان را برمی‌گرداند تا تکمیل و ذخیره کنید."
      action={<Space direction="vertical" size={4}>
        <Button size="small" type="primary" onClick={() => onRestore(draft.restore())}>ادامه</Button>
        <Button size="small" danger onClick={draft.discard}>دور بریز</Button>
      </Space>} />
  );
}
